export const ServiceDomainGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            description: 'description',
            isEnabled: 'isEnabled',
            company: 'company',
            contact: 'contact',
            email: 'email',
            serverGroupName: 'serverGroupName',
            availableServerGroups: 'availableServerGroups',
            heartbeatIntervalType: 'heartbeatIntervalType',
            defaultHeartbeatInterval: 'defaultHeartbeatInterval',
            customHeartbeatInterval: 'customHeartbeatInterval',
            heartbeatIntervalTypeValues: {
                defult: 'Default',
                custom: 'Custom'
            }
        },
        notifications: {
            pageId: 'notifications',
            isEnableMonitor: 'isEnableMonitor'
        },
        history: {
            pageId: 'history',
            createTime: 'createTime',
            lastTime: 'lastTime'
        }
    }
}


export const ServiceDomainGetListSchema = {
    name: 'name',
    description: 'description',
    serverGroup: 'serverGroup',
    company: 'company',
    contact: 'contact',
    email: 'email',
    enabled: 'enabled',
    tenantId: 'tenantId',
    customHeartbeatInterval: 'customHeartbeatInterval'
}

export const ServiceDomainCreateSchema = {
    name: 'name',
    description: 'description',
    company: 'company',
    contact: 'contact',
    email: 'email',
    serverGroup: 'serverGroup',
    enableTwoStepAuthentication: 'enableTwoStepAuthentication'
}

export const ServiceDomainFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    serverGroups: 'serverGroups'
}